import React, { PureComponent, Fragment } from 'react';
import { Link } from 'react-router-dom';
import * as Func from '../../../../../helpers/functions';
import { PATHS } from '../../../../../constants/Define';
import { ListComponent, StatusComponent } from "../../../common/component/Index";
import { withTranslation } from "react-i18next";
import { Icon, Tooltip } from 'antd';
import { DragSource, DropTarget } from 'react-dnd';
import Ripple from '../../../common/component/Ripple';
import BookablePackageRate from '../../../../../models/BookablePackageRate';
import { FlagIconsRatePlan } from '../../../common/component/TranslateButton';
import _, { isEqual } from 'lodash';
import './style.less'
import EllipsisText from '../../../common/component/EllipsisText';
import * as HMS from "../../../common/component/Index";
import * as ANT from 'antd';

const ListCols = ['id', 'amenityId', 'typeRate', 'dc', 'imageLink', 'code', 'name', 'description', 'calculationRule', 'postingRhythm',  'shortDescription', 'isStatus', 'isActive', 'seq', 'translations'];
const ModelFields = Object.getOwnPropertyNames(new BookablePackageRate());

let dragingIndex = -1;

class BodyRow extends React.Component {
    render() {
      const { isOver, connectDragSource, connectDropTarget, moveRow, getListRates, ...restProps } = this.props;
      const style = { ...restProps.style, cursor: 'move' };
      let { className } = restProps;
      if (isOver) {
        if (restProps.index > dragingIndex) {
          className += ' drop-over-downward';
        }
        if (restProps.index < dragingIndex) {
          className += ' drop-over-upward';
        }
      }
  
      return connectDragSource(
        connectDropTarget(<tr {...restProps} className={className} style={style} />),
      );
    }
}

class BookablePackageRateList extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
          itemRow: {},
          titleItemTable: Func.getTitleTable(
            ListCols,
            ["action"],
            ["id", "shortDescription", "dc"]
          ),
          modelItem: ModelFields,
          componentTable: {
            amenityId: {
              key: "amenityId",
              render: (text, record) => {
                return(text ? <img className='amenity-table-config' src={this.convertUrlImage(text)} alt={record?.name}/> : <></>)
              }
            },
            typeRate: {
              key: "DC",
              align: "center",
              // filters: [
              //     { value: Object.entries(HOTEL.TYPE_RATE[CONFIG.ENV])[0][0], text: this.props.t(`item.rate.filters.hotel`) },
              //     { value: Object.entries(HOTEL.TYPE_RATE[CONFIG.ENV])[1][0], text: this.props.t(`item.rate.filters.bundle`) },
              // ],
              // render: (text, record) => record.dc &&
              //   record.dc.map(typeId => <StatusComponent color={HOTEL.TYPE_RATE[CONFIG.ENV][typeId] === 'Bundle' ? 'geekblue' : 'red' }
              //                               label={HOTEL.TYPE_RATE[CONFIG.ENV][typeId]} />)
              render: (text, record) => (
                <StatusComponent
                  color="red"
                  label={this.props.t(`item.rate.filters.hotel`)}
                />
              ),
            },
            name: {
              key: "Name",
              width: 150,
              filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => (
                <HMS.FilterDropdown
                  setSelectedKeys={setSelectedKeys}
                  selectedKeys={selectedKeys}
                  confirm={confirm}
                  clearFilters={clearFilters}
                ></HMS.FilterDropdown>
              ),
              filterIcon: (filtered) => (
                <ANT.Icon
                  type="search"
                  style={{ color: filtered ? "#1890ff" : undefined }}
                />
              ),
              render: (text, record) => (
                <EllipsisText
                  title={text}
                  content={text}
                  contentMaxWidth={150}
                  overlayClassName={"max-width-500"}
                  overlayComponent={Tooltip}
                />
              ),
            },
            imageLink: {
              key: "imageLink",
              align: "center",
              render: (text, record) => {
                return(text ? <img className='img-table-config' src={this.convertUrlImage(text)} alt={record?.name}/> : <></>)
              }
            },
            code: {
              key: "Code",
              align: "center",
              filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => (
                <HMS.FilterDropdown
                  setSelectedKeys={setSelectedKeys}
                  selectedKeys={selectedKeys}
                  confirm={confirm}
                  clearFilters={clearFilters}
                ></HMS.FilterDropdown>
              ),
              filterIcon: (filtered) => (
                <ANT.Icon
                  type="search"
                  style={{ color: filtered ? "#1890ff" : undefined }}
                />
              ),
            },
            description: {
              key: "description",
              width: 150,
              render: (text, record) => (
                <EllipsisText
                  title={text}
                  content={text}
                  contentMaxWidth={150}
                  overlayClassName={"max-width-500"}
                  overlayComponent={Tooltip}
                />
              ),
            },
            calculationRule: {
              key: 'calculationRule',
              width: 200,
            },
            isStatus: {
              key: "Status",
              width: 100,
              filters: [
                { value: true, text: this.props.t(`item.rate.filters.active`) },
                {
                  value: false,
                  text: this.props.t(`item.rate.filters.deActive`),
                },
              ],
              render: (status, record) => (
                <StatusComponent
                  color={status ? "green" : "red"}
                  label={
                    status
                      ? this.props.t("item.rate.active")
                      : this.props.t("item.rate.deactive")
                  }
                />
              ),
            },
            isActive: {
              width: 120,
              key: "IsActive",
              filters: [
                { value: true, text: this.props.t(`item.rate.filters.active`) },
                {
                  value: false,
                  text: this.props.t(`item.rate.filters.deActive`),
                },
              ],
              render: (isActive, record) => {
                return (
                  <ANT.Switch
                    checkedChildren={this.props.t("item.rate.filters.active")}
                    unCheckedChildren={this.props.t(
                      "item.rate.filters.deActiveShort"
                    )}
                    checked={isActive}
                    style={{ width: "100%" }}
                    loading={this.props.loadingStatus}
                    disabled={this.props.isSort || !this.props.permisions?.allowUpdate}
                    onChange={value => this.props.onUpdateActive(value, record)}
                  />
                );
              },
            },
            translations: {
              key: "translations",
              width: 150,
              render: (text, record) => (
                <FlagIconsRatePlan languages={record.translations} />
              ),
            },
            action: {
              width: 100,
              align: "center",
              key: "action",
              fixed: 'right',
              render: (text, record) => this.renderEditComponent(record),
            },
          },
          filters: {},
          dataListRate: [],
          selectedFields: [],
          headSelectedIndex: 0,
          firstSelectedIndex: 0,
        };
    }

    clearItemSelection() {
      this.setState({ selectedFields: [], headSelectedIndex: 0, firstSelectedIndex: 0 });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.dataList && !isEqual(nextProps.dataList, this.props.dataList)) {
            this.setState({ dataListRate: nextProps.dataList });
            this.clearItemSelection();
        }
        if(!nextProps.isSort || !isEqual(nextProps.isSort, this.props.isSort)){
          this.clearItemSelection();
        }
    }

    componentDidMount() {
    }

    rowSource = {
        beginDrag(props) {
          let dragFields;
          let headSelect;
          if (props.selectedFields.find(field => field.id === props.record.id)) {
            dragFields = props.selectedFields;
            headSelect = props.headSelectedIndex;
          } else {
            dragFields = [props.record];
            headSelect = props.index;
          }
          return {
            index: props.index,
            dragFields: dragFields,
            headSelectedIndex: headSelect
          };
        },
    };

    rowTarget = {
        drop(props, monitor) {
          const dragIndex = monitor.getItem().index;
          const dragFields = monitor.getItem().dragFields;
          const headSelect = monitor.getItem().headSelectedIndex;
          const hoverIndex = props.index;
          if (dragIndex === hoverIndex) {
            return;
          }
          props.moveRow(hoverIndex, dragFields, headSelect);
          monitor.getItem().index = hoverIndex;
        },
      };

    DragableBodyRow = DropTarget('row', this.rowTarget, (connect, monitor) => ({
        connectDropTarget: connect.dropTarget(),
        isOver: monitor.isOver(),
      }))(
        DragSource('row', this.rowSource, connect => ({
          connectDragSource: connect.dragSource(),
        }))(BodyRow),
      );

    components = {
        body: {
          row: this.DragableBodyRow,
        },
    };

    async handleRowSelection(shiftKey, index) {
      // if(index < this.state.firstSelectedIndex || !this.state.firstSelectedIndex){
      //   if(shiftKey && !this.state.firstSelectedIndex){
      //     await this.setState({firstSelectedIndex: 0});
      //   }else{
      //     await this.setState({firstSelectedIndex: index});
      //   }
      // }
      this.handleItemSelection(index, shiftKey)
    }

    handleItemSelection(index, shiftKey) {
      let { firstSelectedIndex } = this.state;
      let selectedFields;
      const fields = this.state.dataListRate;
      const field = index < 0 ? '' : fields[index];
      const lastSelectedIndex = index;
      if (!shiftKey) {
        this.setState({firstSelectedIndex: index, headSelectedIndex: index});
        selectedFields = [field];
      } else if (shiftKey) {
        if(index > firstSelectedIndex){
          selectedFields = [].concat(fields.slice(this.state.firstSelectedIndex, index + 1));
          this.setState({headSelectedIndex: firstSelectedIndex});
        }else{
          selectedFields = [].concat(fields.slice(index, this.state.firstSelectedIndex + 1));
          this.setState({headSelectedIndex: index});
        }
      }
      const finalList = fields ? fields
        .filter(f => selectedFields.find(a => a === f)) : [];
      this.setState({ selectedFields: finalList });
    }

    convertUrlImage(url) {
      return url?.includes('https://') ? url : `https://${url}`
    }

    render() {
        const { loading, isSort, moveRow } = this.props;
        const { titleItemTable, modelItem, componentTable, dataListRate, selectedFields, headSelectedIndex } = this.state;
        return (
            <ListComponent
                tableKey="bookable-package-rate-list"
                scroll={{ x: 1500 }}
                rowClassName={(record, index) => selectedFields.findIndex(item => item.id === record.id) > -1 && 'table-row-light'}
                classChildren="p-0" classParent="m-0"
                rowKey={(record, k) => record.id ? record.id : k}
                loading={{ spinning: loading, size: 'large' }}
                dataSource={Func.getDataSource(dataListRate || [], modelItem)}
                columns={Func.columnsTable({
                    titleTable: titleItemTable,
                    component: componentTable,
                    itemName: 'bookablePackageRate'
                })}
                onChange={this.props.onChange}
                componentTableList={{}}
                components={isSort && this.components}
                onRow={(record, index) => ({
                    record,
                    index,
                    moveRow,
                    onClick: (e) => isSort && this.handleRowSelection(e.shiftKey, index),
                    selectedFields,
                    headSelectedIndex
                })}
            />
        );
    }

    renderEditComponent(item) {
        const { t, permisions, hotelId } = this.props;
        const onSyncItem = (item) => {
          this.props.syncOneBookablePackageRate(item.bookableId);
        }
        return (
            <Fragment>
                {
                    permisions && permisions.allowUpdate &&
                    <Link to={Func.getPathWithParams(PATHS.BOOKABLE_PACKAGE_RATE.DETAIL.path, { hotel_id: hotelId, id: item.id })} className={`mr-2 colorPrimary`}>
                        <Ripple><Icon type="form" className="fs20" /></Ripple>
                    </Link>
                }

                {
                  permisions && permisions.allowSync && (
                    <Ripple>
                      <Icon type="sync" style={{padding: '0 10px'}} className="fs20" onClick={() => onSyncItem(item)}/>
                    </Ripple>
                  )
                }
            </Fragment>
        )
    }
}

export default withTranslation()(BookablePackageRateList);
